import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faRocket,
  faTag,
  faRightToBracket,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./ComingSoonPage.module.css";

const PAGE_CONFIG = {
  features: {
    title: "Features",
    icon: faRocket,
    description: "Discover everything Softindex Agent can do—from document analysis to AI insights. We're building a comprehensive feature showcase.",
  },
  pricing: {
    title: "Pricing",
    icon: faTag,
    description: "Flexible plans for teams and individuals. Pricing tiers and options will be available soon.",
  },
  login: {
    title: "Login",
    icon: faRightToBracket,
    description: "User accounts and authentication are in development. You can still use the app to analyze files without an account.",
  },
};

const ComingSoonPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname.replace("/", "") || "features";
  const pageInfo = PAGE_CONFIG[path] || PAGE_CONFIG.features;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <FontAwesomeIcon icon={pageInfo.icon} className={styles.icon} />
        </div>

        {/* Main Title */}
        <h1 className={styles.title}>Coming Soon</h1>
        
        {/* Subtitle */}
        <p className={styles.subtitle}>
          <strong>{pageInfo.title}</strong> is currently under development
        </p>

        <p className={styles.description}>
          {pageInfo.description}
          <br />
          Stay tuned for updates.
        </p>

        {/* Features Preview */}
        <div className={styles.featuresPreview}>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>🚀</div>
            <h3 className={styles.featureTitle}>Powerful Analytics</h3>
            <p className={styles.featureText}>
              Advanced AI-powered analysis for your documents
            </p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>📊</div>
            <h3 className={styles.featureTitle}>Real-time Insights</h3>
            <p className={styles.featureText}>
              Get instant feedback and visualizations
            </p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>🔒</div>
            <h3 className={styles.featureTitle}>Secure & Private</h3>
            <p className={styles.featureText}>
              Your data is protected with enterprise-grade security
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className={styles.actions}>
          <button
            className={styles.primaryButton}
            onClick={() => navigate("/home")}
          >
            <FontAwesomeIcon icon={faHouse} />
            <span>Go to Home</span>
          </button>
          <button
            className={styles.secondaryButton}
            onClick={() => navigate(-1)}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>Go Back</span>
          </button>
        </div>

        {/* Progress Indicator */}
        <div className={styles.progressSection}>
          <p className={styles.progressLabel}>Development Progress</p>
          <div className={styles.progressBar}>
            <div className={styles.progressFill} style={{ width: "65%" }}></div>
          </div>
          <p className={styles.progressText}>65% Complete</p>
        </div>
      </div>

      {/* Background decoration */}
      <div className={styles.bgDecoration}>
        <div className={styles.circle1}></div>
        <div className={styles.circle2}></div>
        <div className={styles.circle3}></div>
      </div>
    </div>
  );
};

export default ComingSoonPage;

